module.exports = __webpack_public_path__ + "static/media/journal-whills.351cbf58.svg";